export const partPropertyCategories = {
    terminal: "Terminal",
    integratedCircuit: "Integrated Circuits",
    routeBranchPoint: "Route Branch Point",
    ground: "Ground",
};
//# sourceMappingURL=propertyCategories.js.map